/**
 * will be loaded by react scripts during build
 *
 * all "custom" environment variables must be prefixed with `REACT_APP_`
 *
 * _all_ environment variable values are replaced during build with their _actual_
 * values. Assume anything loaded from process.env to be publicly available
 */
const e = process.env

/**
 * @default
 * 'development'
 */
export const NODE_ENV = e.NODE_ENV ?? 'development'

/**
 * only used by react-scripts in public/index.html
 *
 * for production deploys, it should be `/`
 *
 * Replaced with the URL of the `public` folder during the build.
 *
 * Only files inside the `public` folder can be referenced from index.html
 */
export const PUBLIC_URL = e.PUBLIC_URL ?? '/'

/**
 * @default
 * 'http://localhost:5000'
 */
export const REACT_APP_BACK_END_URL =
  e.REACT_APP_BACK_END_URL ?? 'http://localhost:5000'

/**
 * Enables Sentry error reporting and structured logs.
 *
 * The prod and dev deploy workflows set this value explicitly. Localhost
 * behavior is controlled by `apps/web/.env`.
 *
 * @default
 * false
 */
export const SENTRY_ENABLE_LOGS = e.REACT_APP_SENTRY_ENABLE_LOGS === 'true'

/**
 * The Sentry environment used to group logs and events.
 *
 * Localhost labels are based on `REACT_APP_USER_ID`.
 *
 * @default `local-${REACT_APP_USER_ID}` in localhost, otherwise NODE_ENV
 */
export const SENTRY_ENVIRONMENT =
  NODE_ENV === 'development'
    ? `local-${e.REACT_APP_USER_ID ?? 'unknown'}`
    : NODE_ENV

/**
 * @default
 * 'http://localhost:5000/auth/login'
 */
export const REACT_APP_LOGIN_URL =
  e.REACT_APP_LOGIN_URL ?? 'http://localhost:5000/auth/login'
